export const jhhDefaultFeatures = [
  "BOOK_LAB_TESTS",
  "CONSULT_DOCTORS",
  "CREATE_FAMILY_PROFILE",
  "SAVE_AND_SHARE_MEDICAL_REPORTS",
  "TRACK_YOUR_HEALTH_STATUS_AND_MORE",
];

export const jhhCreateProfileFeatures = [
  "YOU_CAN_CREATE_MULTIPLE_PROFILES_WITH_YOUR_NUMBER",
  "YOU_CAN_ALSO_CONNECT_YOUR_FAMILY_MEMBER_MOBILE_NUMBER_TO_YOUR_ACCOUNT",
];

